import { useSearchParams } from "@remix-run/react";
import { Search } from "@made-people/blueprint-search";
import { AlgoliaSearchPayload } from "@made-people/grease-algolia";
import { MissMaryAlgoliaSearchResultsProvider } from "../components/features/algolia-search-results-provider/mm-algolia-search-results-provider";
import { useGeneralSettings } from "../hooks/use-general-settings";
import { StoryblokComponent } from "@made-people/grease-storyblok";
import { SbBlokData } from "@storyblok/js";

export const SearchPageRoute = () => {
  const [searchParams] = useSearchParams();

  const payload = {
    searchQuery: searchParams.get("q") || "",
    algoliaTypeId: "product",
    disjunctiveFacets: ["*"],
  } as AlgoliaSearchPayload;
  const generalSettings = useGeneralSettings();
  const noResultsComponents = generalSettings?.noResultComponents;

  return (
    <div className="max-w-screen-page-max-width mx-auto flex flex-col items-center min-h-[80vh]">
      <MissMaryAlgoliaSearchResultsProvider payload={payload}>
        <Search
          templateProps={{
            template: "shanghai",
            NoResultsComponent: noResultsComponents?.map(
              (component: SbBlokData, index: number) => (
                <StoryblokComponent key={index} blok={component} />
              ),
            ),
            productListSettings: {
              loadingSettings: {
                enabled: true,
              },
            },
          }}
          searchTerm={searchParams.get("q") ?? ""}
        />
      </MissMaryAlgoliaSearchResultsProvider>
    </div>
  );
};
